<template>
  <footer class="footer">
    <div class="footerContainer max-w-5xl mb-24 px-3 md:px-5 p-5 pb-40 pt-6">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-12 mb-5">
          <ul class="footerNav -ml-3 md:-ml-4">
            <li class="footerNav-item"><router-link :to="`/home`">Home</router-link></li>
            <li class="footerNav-item">
              <router-link :to="`/case-studies`">Case studies</router-link>
            </li>
            <li class="footerNav-item">
              <router-link :to="`/our-people`">Our people</router-link>
            </li>
            <li class="footerNav-item">
              <router-link :to="{ name: 'products-index' }">Products</router-link>
            </li>
            <li class="footerNav-item" @click.prevent="Store.toggleContactUsModal()">
              <a href="#">Contact us</a>
            </li>
            <li
              class="footerNav-item border-l border-grey-700"
              @click.prevent="Store.toggleContactUsModal()"
            >
              <a
                href="https://au.linkedin.com/company/pipefish-pty-ltd"
                target="_blank"
                rel="noopener"
                class="linkedin inline-block align-middle"
              >
                <svgicon
                  class="inline-block pr-1 align-middle -mt-1"
                  name="linkedin-original"
                  title="Follow us on LinkedIn"
                  width="22"
                  height="22"
                />
                Follow us on LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-6 sm:col-span-6 footer-links footer-links-small pb-5 mb-5">
          <div class="footer-copyright">
            Copyright &copy; {{ currentYear }} Pipefish Pty Ltd
            <div class="email">
              <a
                href="mailto:info@pipefish.com.au"
                @click.stop.prevent="Store.dispatch('toggleContactUsModal')"
                >info@pipefish.com.au</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 partner-logos">
        <div class="col-span-12 sm:col-span-2">
          <a href="https://www.wit.org.au" target="_blank"
            ><img
              class="wit my-2"
              src="~@/assets/images/wit-sponsor-logo@2x.png"
              alt="Women in Technology Sponsor"
              title="Pipefish is a proud sponsor of Women in Technology"
              border="0"
          /></a>
        </div>
        <div class="col-span-12 sm:col-span-10">
          <a href="https://www.focushq.com/" target="_blank"
            ><img
              class="fhq block my-2"
              src="~@/assets/images/FHQ_logo_white.png"
              alt="https://www.focushq.com/"
              title="Pipefish partners with Focus HQ"
              border="0"
          /></a>
          <a href="https://cas.com.au/what-is-iso9001-certification-2/" target="_blank"
            ><img
              class="compass block mt-8 sm:mt-8"
              src="~@/assets/images/COMPASS_9001_circle.png"
              alt="Compass Assurance ISO 9001 Quality"
              title="Pipefish is Compass Assurance ISO 9001 Quality certified."
              border="0"
          /></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// import ContactUs from '@/components/ContactUs.vue';
import '@/components/svg/home';
import '@/components/svg/linkedin-original';
import '@/components/svg/pipefish-logo-on-dark';
import Vue from 'vue';
import vueSmoothScroll from 'vue-smoothscroll';
Vue.use(vueSmoothScroll);
export default {
  name: 'Footer',
  computed: {
    modal: {
      get: function() {
        return this.Store.state.contactUsModal;
      },
      set: function() {}
    },
    currentYear: function() {
      return new Date().getFullYear();
    }
  },
  methods: {
    scrollTo: function(scrollTo) {
      if (this.$router.currentRoute.name.includes('home')) {
        let anchor = scrollTo.replace(/-/g, '');
        this.$SmoothScroll(document.getElementById(anchor), 800, null, null, 'y');
      } else {
        this.$router.push({ name: 'home-' + scrollTo });
      }
    },
    navTo: function(route, params) {
      if (this.$router.currentRoute.name.includes('case-studies')) {
        this.$SmoothScroll(
          document.getElementsByClassName('sect-content')[0],
          800,
          null,
          null,
          'y'
        );
      } else {
        this.$router.push({ name: route, params: params });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: darken($Grey5Chicago, 20%);
  min-width: 200px;
  z-index: 200;
  position: relative;
  padding: 0 0 50px 0;
  margin: 0px 0 0 0;
}
.footerContainer {
  position: relative;
  margin: 0 auto;
  // padding: 30px 0 150px 0;
  width: 100%;
  // max-width: 1000px;
  color: $Grey5;
  font-size: 9pt;
}
.footerNav {
  padding: 0 0;
  margin: 0 0;
  list-style: none;
  font-size: 14px;
  @include media('>=medium') {
    font-size: 16px;
  }
  &-item {
    display: inline-block;
    padding: 0;
    margin: 0;
    list-style: none;
    a {
      display: block;
      padding: 8px 10px;
      text-decoration: none;
      // text-transform: uppercase;
      color: $Grey2;
      @include media('>=medium') {
        padding: 8px 15px;
      }
      &:hover {
        text-decoration: underline;
        color: $PriWhite;
        // background-color: darken($Grey5Chicago, 23%);
      }
    }
  }
}
.footer-links {
  font-size: 14px;
  color: $Grey3;
  @include media('>=medium') {
  }
  a {
    &:hover {
      text-decoration: underline;
      color: #fff;
    }
  }
  &--small {
    font-size: 14px;
  }
}

.linkedin {
  svg {
    opacity: 0.5;
  }
  &:hover {
    text-decoration: underline;
    svg {
      opacity: 0.8;
    }
  }
}
.partner-logos {
  img,
  svg {
    max-width: auto !important;
    // margin: 1rem 0;
  }
  .compass {
    width: 60px !important;
  }
  .wit {
    width: 80px !important;
  }
  .fhq {
    width: 170px !important;
  }
}
</style>
